<template>
    <div class="relief">
      <div class="box">
        <p id="text">{{text}}</p>
      </div>
    </div>
</template>

<script>
    export default {
        name: "relief",
        mounted(){
			this.timer=setInterval(function(){
				let width=-$('#text').width()
				let left =$('#text').position().left
				if(left> width){
					left-=1
				}else{
					left=0
				}
				$('#text').css("left",left)
			},24)
        },
		destroyed(){
			window.clearInterval(this.timer)
		},
        data:()=>{
            return{
              text:'本项目推广名为“贵阳·融创城”，地名办核准名为“贵阳经济技术开发区数字安全小镇（一期）”。开发公司为：“贵阳经开融创黔城房地产开发有限公司”。本资料为要约邀请，不作为要约或承诺。相关宣传内容不排除因政府相关规划、规定及出卖人分期规划、未能控制等原因而发生变化。出卖人可能会不定期对宣传材料进行修改。买卖双方的权利义务以双方签订的《商品房买卖合同》及其补充协议、附件等书面文件为准。本资料所发布的内容为2019年12月2日前的信息，敬请留意最新资料。教育配套信息来源于地块属性规划，仅供参考。学校的名称、建成时间、开办学性质、办学规模、学位设置、开学时间、招生条件、收费标准及招生区域划定等均存在未确定或者调整的可能，出卖人对此不作任何承诺，须以政府教育主管部门及校方的最新政策为准。交通配套信息来源于地块属性数据，市政配套信息来源于地块属性数据，仅供参考。交通规划设置、市政配套设置不排除因政府规划、政策规定及出卖人未能控制的原因而发生变化，本资料旨在提供相关信息，不代表着出卖人对此作出要约或承诺。S4号线数据来http://www.guiyang.gov.cn/ztzl/gygdjt/index.html。本宣传资料对商业的具体业态、开业时间等仅作介绍，不代表出卖人对此作出要约或承诺，具体以经营者实际经营为准。本宣传资料所涉及的户型仅供示意参考，其装修、家具、陈设等非交付标准，不属于交付范围。不同户型的面积尺寸、功能布局、空间分割、门窗/管井形态位置等均有不同。相同户型因楼栋、楼层、单元等差别，局部结构、面积等也可能不同，具体以政府部门最终审定的图纸和销售合同为准。医疗配套信息来源于地块属性规划，仅供参考，出卖人对此不作任何承诺，须以政府相关部门公示信息为准；公园配套信息来源于地块属性规划，仅供参考，出卖人对此不作任何承诺，须以政府相关部门公示信息为准；',
				timer:'',
			}
        },
		methods:{
			
			}

    }
</script>

<style scoped>
	.relief{
		width: 100%;
		height:8px;
		position: fixed;
		bottom: 8%;
		left: 0;
        opacity: 0.5;
        z-index: 20;
	}
	.box{
		height: 8px;
		width: 100%;
		line-height: 8px;
		/*background-color: rgba(0,0,0,0.5);*/
		position: relative;
		 white-space:pre-wrap;
	}
	p{
		line-height:8px;
		font-size:4px;
		position: absolute;
		padding-left: 20px;
		padding-right: 20px;
		top: 0;
		left: 0;
		 white-space:nowrap;
		 color: #ffffff;
		 font-family: "微软雅黑";
		 /* animation: run 30s linear infinite; */
		 
	}
	@keyframes run{
		from{
			left: 0;
		}
		to{
			left: -100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/ltRelief.vue